import React from 'react';

const styles = {
  section: {
    position: 'relative',
    zIndex: 1,
    padding: '100px 24px',
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  label: {
    display: 'inline-block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#3b82f6',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '16px',
  },
  title: {
    fontSize: 'clamp(28px, 4vw, 42px)',
    fontWeight: '700',
    fontFamily: "'Space Grotesk', sans-serif",
    color: '#fff',
    marginBottom: '16px',
  },
  subtitle: {
    fontSize: '18px',
    color: '#94a3b8',
    marginBottom: '48px',
  },
};

export const SectionWrapper = ({
  id,
  children,
  label,
  title,
  subtitle,
  isVisible = true,
  backgroundColor,
  style = {},
}) => {
  const sectionStyle = {
    ...styles.section,
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
    backgroundColor,
    ...style,
  };

  return (
    <section id={id} style={sectionStyle}>
      <div style={styles.inner}>
        {label && <span style={styles.label}>{label}</span>}
        {title && <h2 style={styles.title}>{title}</h2>}
        {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
        {children}
      </div>
    </section>
  );
};
